import React from "react";
import { useAuth0 } from "@auth0/auth0-react";

// For sidebar items that should only be visible to Plumb Ditch users (and admins/developers)
const ALLOWED_ROLES = ["Administrator", "Developer", "Plumb Ditch"];

const PlumbDitchVisibilityFilter = ({ children }) => {
  const { user, isAuthenticated } = useAuth0();

  if (!user) return <React.Fragment />;

  const roles = user[`${process.env.REACT_APP_AUDIENCE}/roles`];
  let hasAccess = false;
  if (roles && roles.filter((x) => ALLOWED_ROLES.includes(x)).length > 0) {
    hasAccess = true;
  }

  if (!isAuthenticated || !hasAccess) {
    return <React.Fragment />;
  }

  return children;
};

export default PlumbDitchVisibilityFilter;
